// extracted by mini-css-extract-plugin
export default {"smallText":"Legal_smallText__+O0ni"};